import { getClientId } from "@/data/repository/ClientRepository";

import { SessionCacheModule } from "@/store/modules/SessionCacheModule";

export const STORAGE_KEY_LAST_VISITED_ITEM_LEVEL_1 = "STORAGE_KEY_LAST_VISITED_ITEM_LEVEL_1";
export const STORAGE_KEY_LAST_VISITED_ITEM_LEVEL_2 = "STORAGE_KEY_LAST_VISITED_ITEM_LEVEL_2";
export const STORAGE_KEY_LAST_VISITED_ITEM_LEVEL_3 = "STORAGE_KEY_LAST_VISITED_ITEM_LEVEL_3";
export const STORAGE_KEY_LAST_VISITED_ITEM_LEVEL_4 = "STORAGE_KEY_LAST_VISITED_ITEM_LEVEL_4";
export const STORAGE_KEY_LAST_VISITED_ITEM_LEVEL_5 = "STORAGE_KEY_LAST_VISITED_ITEM_LEVEL_5";

export function isSessionStorageAvailable() {
  try {
    if (window.sessionStorage.getItem("isAvailable")) {
      return true;
    }

    window.sessionStorage.setItem("isAvailable", "true");
  } catch (error) {
    return false;
  }

  return true;
}

export function clearSecureLocalStorage() {
  if (isSessionStorageAvailable()) {
    window.sessionStorage.clear();
  } else {
    SessionCacheModule.clear();
  }
}

export function makeKeyUniqueForClient(key: string) {
  return getClientId().substring(0, 10) + key;
}

export function getValue(key: string) {
  const uniqueClientKey = makeKeyUniqueForClient(key);

  if (isSessionStorageAvailable()) {
    return window.sessionStorage.getItem(uniqueClientKey);
  } else {
    return SessionCacheModule.value(uniqueClientKey);
  }
}

export function removeValue(key: string) {
  const uniqueClientKey = makeKeyUniqueForClient(key);

  if (isSessionStorageAvailable()) {
    window.sessionStorage.removeItem(uniqueClientKey);
  } else {
    SessionCacheModule.setValue({
      key: uniqueClientKey,
      value: null,
    });
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function setValue(key: string, value: any) {
  const uniqueClientKey = makeKeyUniqueForClient(key);

  if (isSessionStorageAvailable()) {
    window.sessionStorage.setItem(uniqueClientKey, value);
  } else {
    SessionCacheModule.setValue({
      key: uniqueClientKey,
      value: value,
    });
  }
}

export function setNumber(key: string, value?: number | null) {
  if (value != null) {
    setValue(key, value);
  } else {
    removeValue(key);
  }
}

export function getNumber(key: string) {
  const value = getValue(key);

  if (value !== null && value !== undefined && value !== "") {
    return Number(value);
  } else {
    return null;
  }
}

export function setString(key: string, value?: string | null) {
  if (value) {
    setValue(key, value);
  } else {
    removeValue(key);
  }
}

export function getString(key: string) {
  const value = getValue(key) as string;

  if (value) {
    return value;
  } else {
    return null;
  }
}

export function setBoolean(key: string, value?: boolean | null) {
  if (value !== undefined && value !== null) {
    setValue(key, value ? "true" : "false");
  } else {
    removeValue(key);
  }
}

export function getBoolean(key: string) {
  const value = getValue(key);

  if (value !== undefined && value !== "") {
    return value === "true";
  } else {
    return null;
  }
}
